import { Component, Input } from '@angular/core';
import { DialogNgbService } from '@motivforce/mx-library-angular';

import { SalesAccelerator } from '../../../core/model/core/sales-accelerator';

@Component({
  selector: 'app-sales-accelerator-item',
  templateUrl: './sales-accelerator-item.component.html',
  styleUrls: ['./sales-accelerator-item.component.scss'],
})
export class SalesAcceleratorItemComponent {
  @Input() item: SalesAccelerator;

  constructor(private dialog: DialogNgbService) {}

  openMessage(message: string): void {
    this.dialog.openFeatureDialog('salesAcceleratorsInfoDialog', [message], { size: 'lg' });
  }
}
